import { FC } from 'react';
import { CalculatedUnscoredMetrics } from 'modules/intelligentInsights/brandAffinityInsights/types';
import {
  SubtitleBold,
  UnscoredMessagingActivityCard,
  UnscoredMessagingActivityMetricsContainer,
  UnscoredMessagingActivityTitle,
} from 'modules/intelligentInsights/brandAffinityInsights/components/breakdownByAffinity/cohortTabContent/contributingFactorsCards/UnscoredMessagingActivity.styles';
import {
  MarginlessBody2,
  MarginlessBody2Bold,
} from 'modules/intelligentInsights/brandAffinityInsights/components/common.styles';
import { localizeCompactNumber } from 'utils/l10n';
import {
  formatOneDecimalPlaceOption,
  UNSCORED_ANALYTIC_METRICS,
} from 'modules/intelligentInsights/brandAffinityInsights/constants';

export const UnscoredMessagingActivityId = 'unscored-messaging-activity';

export interface UnscoredMessagingActivityProps {
  unscoredMetrics: CalculatedUnscoredMetrics;
}
export const UnscoredMessagingActivity: FC<UnscoredMessagingActivityProps> = ({
  unscoredMetrics,
}) => {
  return (
    <UnscoredMessagingActivityCard data-test={UnscoredMessagingActivityId}>
      <UnscoredMessagingActivityTitle>Messaging Activity</UnscoredMessagingActivityTitle>
      <UnscoredMessagingActivityMetricsContainer>
        <SubtitleBold>{UNSCORED_ANALYTIC_METRICS.totalSends}</SubtitleBold>
        <SubtitleBold>
          {localizeCompactNumber(
            unscoredMetrics.totalSends,
            undefined,
            formatOneDecimalPlaceOption,
          )}
        </SubtitleBold>
        <MarginlessBody2>{UNSCORED_ANALYTIC_METRICS.sendSkips}</MarginlessBody2>
        <MarginlessBody2Bold>
          {localizeCompactNumber(
            unscoredMetrics.totalSendSkips,
            undefined,
            formatOneDecimalPlaceOption,
          )}
        </MarginlessBody2Bold>
        <MarginlessBody2>{UNSCORED_ANALYTIC_METRICS.unsubscribes}</MarginlessBody2>
        <MarginlessBody2Bold>
          {localizeCompactNumber(
            unscoredMetrics.uniqueUsersUnsub,
            undefined,
            formatOneDecimalPlaceOption,
          )}
        </MarginlessBody2Bold>
      </UnscoredMessagingActivityMetricsContainer>
    </UnscoredMessagingActivityCard>
  );
};
